// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"88":"login-page","143":"main-page","471":"diary-page","528":"calculator-page","931":"regisrtation-page"}[chunkId] || chunkId) + "." + {"55":"7e3dd71e","88":"d5179654","143":"44796256","471":"ec023f1b","528":"7369992c","544":"7194ba0f","600":"f19548a8","931":"8bddaa77","977":"0a48e3da"}[chunkId] + ".chunk.js";
};